import axios from "axios";
import {Adresse} from "@k/global/Adresse";

export type OrderLieferposition  = {
    produkt : string;
    AuwiProdukt : string;
    design : string;
    id : string;
    name : string;
    features : string;
    amount : string;
    preis : string;
    symbol : string;
    gesamtpreis : string;
    rechnungszeile : string;
}


export type Order = {
    bestellnummer:string,
    bestellpositionen:Array<OrderLieferposition>,
    datumBestellt:string,
    gesamtpreis:string,
    lieferadresse:Adresse,
    rechnungsadresse:Adresse,
    spediteur:string|null,
    status:string,
    trackingnummer:string|null,
    versandt:"0"|"1",
    zahlart:string
}



export default {
    state: () => ({
        orders:[] as Order[]
    }),
    getters: {
        getOrders:state=>state.orders
    },
    mutations: {
        SET_ORDERS(state, orders) {
            state.orders = orders
        }

    },
    actions: {
        loadOrders(context, language) {
            const toSend = new FormData();
            toSend.append("iso", language);

            axios({
                url:"/shoppingcart/php/loadOrders.php",
                method: "post",
                data: toSend
            }
            ).then(response=>context.commit("SET_ORDERS", response.data))
        }
    },
}
